import './App.css'
import React from 'react'
import { useWindowSize } from 'usehooks-ts'
import { ConfigProvider, theme } from 'antd'
import huHU from 'antd/locale/hu_HU'
import { useMemo } from 'react'
import { ResponsiveContext } from './context/responsive-context'
import TimeElapsedCounter  from './components/Elapsed'
import { AudioPlayer } from './components/AudioPlayer'

function App() {
  const { width } = useWindowSize()
  const { token } = theme.useToken()
  const isMobile = useMemo(() => width < token.screenXSMax, [width, token.screenXSMax])
  const useVertical = token.screenLGMin > width
  return (
    <ConfigProvider locale={huHU} theme={{
      token: {
        screenSM: 577,
        screenSMMin: 577,
        screenXSMax: 576,
        screenLG: 1110,
        screenLGMin: 1110,
        screenMDMax: 1109,
      },
    }}>
      <ResponsiveContext value={{
        isMobile,
        useVertical
      }}>
        <div style={{ height: "100vh"}}>
        <TimeElapsedCounter targetDate={new Date(2026, 3, 13, 8, 0, 0)} />
        <AudioPlayer />
        </div>
      </ResponsiveContext>
    </ConfigProvider>
  )
}

export default App
